import React from 'react';
import styled from 'styled-components';
import { clearFix } from 'polished';
import { margin, shade, themify } from '../styles/mixins';
import { withSpacing } from '../lib/hoc/withSpacing';
const StyledSeparator = styled.div.withConfig({
  displayName: "Separator__StyledSeparator",
  componentId: "sc-9cj42i-0"
})(["display:block;height:1px;border:0;border-top:1px solid ", ";padding:0;line-height:1;width:100%;", ";"], x => x.color, clearFix());
const TextSeparator = styled.div.withConfig({
  displayName: "Separator__TextSeparator",
  componentId: "sc-9cj42i-1"
})(["display:block;overflow:hidden;line-height:1;text-align:center;white-space:nowrap;", ";"], clearFix());
const Text = styled.span.withConfig({
  displayName: "Separator__Text",
  componentId: "sc-9cj42i-2"
})(["position:relative;display:inline-block;color:", ";font-size:", ";text-transform:", ";letter-spacing:", ";&::before,&::after{position:absolute;top:50%;width:9999px;height:1px;background:", ";content:'';}&::before{", ";right:100%;}&::after{", ";left:100%;}"], x => shade(0.9, x.color), x => x.theme.type.scale[x.fontSize], x => x.caps ? 'uppercase' : 'none', x => x.caps ? '0.025em' : '0', x => x.color, margin(2, 'r'), margin(2, 'l'));

const SeparatorFunc = ({
  caps = true,
  className,
  color = 'gray',
  fontSize = 5,
  text
}) => text ? /*#__PURE__*/React.createElement(TextSeparator, {
  className: className
}, /*#__PURE__*/React.createElement(Text, {
  color: themify(color),
  fontSize: fontSize,
  caps: caps
}, text)) : /*#__PURE__*/React.createElement(StyledSeparator, {
  className: className,
  color: themify(color)
});

export const Separator = withSpacing(SeparatorFunc);